
import gif from './media/gif';

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
export default {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test">' + '<area shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" tabindex="-1" alt="" src="' + gif + '">';

    return element.querySelector('area');
  }
};
//# sourceMappingURL=focus-area-img-tabindex.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/focus-area-img-tabindex.js
// module id = 174
// module chunks = 0 1